import React, { useEffect, useMemo, useState, useCallback } from "react"
import PropTypes from "prop-types"
import { Link, useParams } from "react-router-dom"
import { isEmpty } from "lodash"
import "bootstrap/dist/css/bootstrap.min.css"
import TableContainer from "../../../../components/Common/TableContainer"
import * as Yup from "yup"
import { useFormik } from "formik"
import Select from "react-select"

//import components
import Breadcrumbs from "../../../../components/Common/Breadcrumb"

// import {
//   getUsers as onGetUsers,
//   addNewUser as onAddNewUser,
//   updateUser as onUpdateUser,
//   deleteUser as onDeleteUser,
// } from "../../../store/actions"

import {
  // Position,
 Name_ar,Name_en,Name_fr,IsActive, Name_services_en
} from "./ListCol"

//redux
import { useSelector, useDispatch } from "react-redux"

import {
  Col,
  Row,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,
  FormFeedback,
  Label,
  Card,
  CardBody,
  DropdownToggle,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  Spinner,
} from "reactstrap"
import DeleteModal from "../../../../components/Common/DeleteModal"
// import { addNewAdmin, deleteAdmin, getAdmins, updateAdmin } from "../../../store/admins/actions"
import { addNewVendor_cat, deleteVendor_cat, getVendor_cats, updateVendor_cat } from "../../../../store/vendor_cat/actions"
import imageBaseUrl from "../../../../helpers/imageBaseUrl"
import Dropzone from "react-dropzone"
import { addNewType_service, deleteType_service, getType_services, updateType_service } from "../../../../store/vendor_types_services/actions"
import { addNewType_setting, deleteType_setting, getType_settings, updateType_setting } from "../../../../store/vendor_types_settings/actions"

function TypeSettingsList() {
  const [modal, setModal] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [offset,setOffset]=useState(0)
  const [page_size, setPageSize] = useState(10)
  const [vendor_cat, setVendor_cat] = useState([])
  const [selectedFiles, setselectedFiles] = useState([])
  const [selectedTypeService,setSelectedTypeService] = useState({label:'',value:''})

const {id:vendor_type_id} = useParams()
  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      name_en: (vendor_cat && vendor_cat.name_en) || "",
      name_ar: (vendor_cat && vendor_cat.name_ar) || "",
      name_fr: (vendor_cat && vendor_cat.name_fr) || "",
      is_active: (vendor_cat && vendor_cat.is_active) || 0,
    },

    validationSchema: Yup.object({
      name_ar: Yup.string().required("name ar is required"),
      name_fr: Yup.string().required("name fr is required"),
      name_en: Yup.string().required("name en is required"),
    }),
    
    onSubmit: values => {

      if (isEdit) {
        const UpdateVendor_cat = {
          id: vendor_cat ? vendor_cat.id : 0,
          name_en: values["name_en"],
          name_fr: values["name_fr"],
          name_ar: values["name_ar"],
          vendor_type_service_id: selectedTypeService?.value,
          is_active: values['is_active'],
        }

        // update vendor_cat
        dispatch(updateType_setting(UpdateVendor_cat))
        dispatch(getType_settings({vendor_type_id,is_active:0,offset,page_size}))
        
        validation.resetForm()
      } else {
        const newVendor_cat = {
           vendor_type_id: vendor_type_id,
          name_en: values["name_en"],
          name_fr: values["name_fr"],
          name_ar: values["name_ar"],
          vendor_type_service_id: selectedTypeService?.value,
          is_active: values['is_active'],
        }
        // save new vendor_cat
        dispatch(addNewType_setting(newVendor_cat))
        dispatch(getType_settings({vendor_type_id,is_active:0,offset,page_size}))

        validation.resetForm()
      }
      // toggle()
    },
  })

  const dispatch = useDispatch()
  const data = useSelector(state => state.vendors.vendortypeSettings.data)
  const services = useSelector(state => state.vendors.vendortypeServices.data)
  const loading = useSelector(state => state.vendors.vendortypeSettings.loading)
  const total_page = useSelector(state => state.vendors.vendortypeSettings.total_page)

  useEffect(() => {
      dispatch(getType_settings({vendor_type_id,is_active:0,offset,page_size}))
  }, [dispatch,offset,page_size])

  useEffect(()=>{
    dispatch(getType_services({vendor_type_id,is_active:1}))
  },[dispatch])
  // useEffect(() => {
  //   if (data && !data.length) {
  //     dispatch(onGetUsers())
  //   }
  // }, [dispatch, data])

  // useEffect(() => {
  // }, [data])

  useEffect(() => {
    if (!isEmpty(data)) {
      setIsEdit(false)
    }
  }, [data])

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false)
      setVendor_cat(null)
    } else {
      setModal(true)
    }
  }, [modal]);

  const handleUserClick = useCallback((arg) => {
    const vendor_cat = arg
    vendor_cat?.image ? setselectedFiles([
      {
        preview:imageBaseUrl+vendor_cat.image
      }
    ]) : setselectedFiles([])
    setVendor_cat({
      id: vendor_cat.id,
      name_ar: vendor_cat.name_ar,
      name_fr: vendor_cat.name_fr,
      name_en: vendor_cat.name_en,
      is_active:vendor_cat.is_active

    })
    setSelectedTypeService({value:vendor_cat.service_id,label:vendor_cat.name_en_services})
    setIsEdit(true)
    toggle()
  }, [toggle])

  //delete vendor_cat
  const [deleteModal, setDeleteModal] = useState(false)

  const onClickDelete = vendor_cat => {
    setVendor_cat(vendor_cat)
    setDeleteModal(true)
  }

  const handleDeleteUser = () => {
    if (vendor_cat.id) {
      dispatch(deleteType_setting(vendor_cat))
      // setDeleteModal(false)
    }
  }
  useEffect(() => {
    if(!loading){
      setDeleteModal(false)
           setModal(false) 
    } 

  },[loading])
  const handleUserClicks = () => {
    setIsEdit(false)
    toggle()
  }
  const columns = useMemo(
    () => [
      {
        Header: "Id",
        accessor: "checkbox",
        disableFilters: true,
        filterable: false,
        Cell: cellProps => {
          return <p>{cellProps.value}</p>
        },
      },
   
      {
        Header: "name english",
        accessor: "name_en",
        filterable: true,
        Cell: cellProps => {
          return <Name_en {...cellProps} />
        },
      },
      {
        Header: "name french",
        accessor: "name_fr",
        filterable: true,
        Cell: cellProps => {
          return <Name_fr {...cellProps} />
        },
      },
      {
        Header: "name arabic",
        accessor: "name_ar",
        filterable: true,
        Cell: cellProps => {
          return <Name_ar {...cellProps} />
        },
      },
      {
        Header: "service",
        accessor: "name_en_services",
        filterable: true,
        Cell: cellProps => {
          return <Name_services_en {...cellProps} />
        },
      },
      {
        Header: "Active",
        accessor: "is_active",
        filterable: true,
        disableFilters: true,

        Cell: cellProps => (
          // {
          //   return <IsActive {...cellProps} />
          // },
          <div className="form-check form-switch form-switch-lg">
            {cellProps.value == 1 ? (
              <input
                disabled={loading}
                onClick={e =>
                  dispatch(
                    updateType_setting({
                      is_active: 0,
                      id: cellProps.row.original.id,
                    })
                  )
                }
                type="checkbox"
                className="form-check-input"
                id="customSwitchsizelg"
                checked={true}
              />
            ) : (
              <input
                disabled={loading}
                onClick={e =>
                  dispatch(
                    updateType_setting({
                      is_active: 1,
                      id: cellProps.row.original.id,
                    })
                  )
                }
                type="checkbox"
                className="form-check-input"
                id="customSwitchsizelg"
                checked={false}
              />
            )}
          </div>
        ),
      },
      {
        Header: "Action",
        accessor: "action",
        disableFilters: true,
        Cell: cellProps => {
          return (
            <div className="d-flex gap-3 users">
              <ul className="list-inline font-size-20 contact-links mb-0">
                <li className="list-inline-item">
                  <Link
                    to="#"
                    className="text-primary"
                    onClick={() => {
                      const data = cellProps.row.original
                      handleUserClick(data)
                    }}
                  >
                    <i className="uil uil-pen font-size-18" id="edittooltip" />
                    <UncontrolledTooltip placement="top" target="edittooltip">
                      Edit
                    </UncontrolledTooltip>
                  </Link>
                </li>
                <li className="list-inline-item">
                  <Link
                    to="#"
                    className="text-danger"
                    onClick={() => {
                      const data = cellProps.row.original
                      onClickDelete(data)
                    }}
                  >
                    <i
                      className="uil uil-trash-alt font-size-18"
                      id="deletetooltip"
                    />
                    <UncontrolledTooltip placement="top" target="deletetooltip">
                      Delete
                    </UncontrolledTooltip>
                  </Link>
                </li>
                {/* <li className="list-inline-item dropdown">
                  <UncontrolledDropdown>
                    <DropdownToggle
                      tag="a"
                      className="text-muted font-size-18 px-2"
                      caret
                    >
                      <i className="uil uil-ellipsis-v"></i>
                    </DropdownToggle>
                    <DropdownMenu className="dropdown-menu-end">
                      <DropdownItem href="#">Action</DropdownItem>
                      <DropdownItem href="#">Another action</DropdownItem>
                      <DropdownItem href="#">Something else here</DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </li> */}
              </ul>
            </div>
          )
        },
      },
    ],
    [handleUserClick]
  )

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
        loading={loading}
      />
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="MENU" breadcrumbItem="Vendor categories" />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={data}
                    isGlobalFilter={true}
                    isAddUsers={true}
                    isAddTableWithoutBorderStrap={true}
                    handleUserClicks={handleUserClicks}
                    setPage={setOffset}
                    page_number={offset}
                    total_pages={total_page}
                    setPageSize={setPageSize}
                    page_size={page_size}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader toggle={toggle} tag="h4">
              {!!isEdit ? "Edit User" : "Add Users"}
            </ModalHeader>
            <ModalBody>
              <Form
                onSubmit={e => {
                  e.preventDefault()
                  validation.handleSubmit()
                  return false
                }}
              >
    
                <Row>
                  <Col className="col-12">
                    {/* <div className="mb-3">
                      <Label className="form-label">Position</Label> */}
                    {/* <Input
                        name="designation"
                        type="designation"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.designation || ""}
                        invalid={
                          validation.touched.designation &&
                          validation.errors.designation
                            ? true
                            : false
                        }
                      /> */}
                    {/* {validation.touched.designation &&
                      validation.errors.designation ? (
                        <FormFeedback type="invalid">
                          {validation.errors.designation}
                        </FormFeedback>
                      ) : null} */}
                    {/* </div> */}
                    <div className="mb-3">
                      <Label className="form-label">Name en</Label>
                      <Input
                        name="name_en"
                        type="text"
                        validate={{
                          required: { value: true },
                        }}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.name_en || ""}
                        invalid={
                          validation.touched.name_en &&
                          validation.errors.name_en
                            ? true
                            : false
                        }
                      />
                      {validation.touched.name_en &&
                      validation.errors.name_en ? (
                        <FormFeedback type="invalid">
                          {validation.errors.name_en}
                        </FormFeedback>
                      ) : null}
                    </div>

                    <div className="mb-3">
                      <Label className="form-label">Name ar</Label>
                      <Input
                        name="name_ar"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.name_ar || ""}
                        invalid={
                          validation.touched.name_ar &&
                          validation.errors.name_ar
                            ? true
                            : false
                        }
                      />
                      {validation.touched.name_ar &&
                      validation.errors.name_ar ? (
                        <FormFeedback type="invalid">
                          {validation.errors.name_ar}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="form-label">Name fr</Label>
                      <Input
                        name="name_fr"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.name_fr || ""}
                        invalid={
                          validation.touched.name_fr &&
                          validation.errors.name_fr
                            ? true
                            : false
                        }
                      />
                      {validation.touched.name_fr &&
                      validation.errors.name_fr ? (
                        <FormFeedback type="invalid">
                          {validation.errors.name_fr}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="form-label">Services</Label>
                      <div className="mb-3">
                        <Select
                          value={selectedTypeService}
                          onChange={option => {
                            setSelectedTypeService(option)
                          }}
                          
                          options={services.map(s=>({label:s.name_en,value:s.id}))}
                          classNamePrefix="select2-selection"
                        />
                      </div>
                    </div>
                    <div className="mb-3">
                      {validation.values.is_active === 1 ? (
                        <input
                          type="checkbox"
                          className="selection-input-4 m-1"
                          defaultChecked
                          onClick={() => (validation.values.is_active = 0)}
                        />
                      ) : (
                        <input
                          type="checkbox"
                          className="selection-input-4 m-1"
                          onClick={() => (validation.values.is_active = 1)}
                        />
                      )}
                      {/* <input
                        type="checkbox"
                        className="selection-input-4 m-1"
                        defaultChecked={
                          validation.values.is_active === 1 ? true : false
                        }
                      /> */}
                            
                      <Label className="form-label">Active</Label>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="text-end">
                      {loading ? (
                        <Spinner
                          type="grow"
                          className="m-1 center"
                          color="primary"
                        />
                      ) : (
                        <button
                          type="submit"
                          className="btn btn-success save-user"
                        >
                          Save
                        </button>
                      )}
                    </div>
                  </Col>
                </Row>
              </Form>
            </ModalBody>
          </Modal>
        </div>
      </div>
    </React.Fragment>
  )
}
TypeSettingsList.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default TypeSettingsList
